import { Timestamp } from '@griply/types';
import { EntryTypes } from 'shared/components/ui/task-detail-checkbox/overdue-context-menu';

export enum SubMenu {
  Priority = 'priority',
  LinkedItem = 'linked-item',
  DeadlineDeadline = 'deadline-deadline',
  ReminderTime = 'reminder-time',
  Date = 'date',
  SelectDate = 'select-date',
  Tags = 'tags',
  Timeslot = 'timeslot',
}

export type OverdueEntryPrompt = {
  type: EntryTypes;
  overdueDate: Timestamp;
  onDate: (date: Timestamp) => void;
};
